import { Fetch } from 'barnyard/utils/';
import * as constants from '../constants';
import { startSubmit, stopSubmit, reset } from 'redux-form';
import { addNotification } from '~/app/common/packages/notifications';


export const buyersFetch = () => (dispatch, getState) => Fetch({
  url: '/api/buyers/buyers/',
  success: (json) => {
    dispatch({
      type: constants.BUYERS_FETCH_SUCCESS,
      entities: _.indexBy(json, 'id')
    });
  }
});

export const buyerFetch = buyer_id => (dispatch, getState) => Fetch({
  url: `/api/buyers/buyer/${buyer_id}/`,
  success: (json) => {
    dispatch({
      type: constants.BUYER_FETCH_SUCCESS,
      entity: Object.assign({ is_detail_view: true }, json),
      buyer_id
    });
  }
});

export const buyerUpdate = (buyer_id, form) => (dispatch, getState) => Fetch({
  url: `/api/corporates/buyer/${buyer_id}/`,
  method: 'PATCH',
  body: form,
  before: (json) => {
    dispatch(startSubmit('buyer'));
    dispatch({
      type: constants.BUYER_UPDATE_REQUEST
    });
  },
  success: (json) => {
    dispatch({
      type: constants.BUYER_UPDATE_SUCCESS,
      entity: json,
      buyer_id
    });
    dispatch(
      stopSubmit('buyer')
    );
    dispatch(
      addNotification({
        value: 'Successfully updated hospital settings'
      })
    );
  },
  failure: (error) => {
    dispatch(stopSubmit('buyer', { _error: 'Error updating hospital' }));
  }
});
